import GlobalClient from "../hermesclient/client";
import { LogicalMailbox, MailboxAddress, asMailboxAddress } from "../hermesclient/types";
import { config } from "../config/app-config";

class NameMappingService {
  async resolve(logical: LogicalMailbox): Promise<MailboxAddress> {
    // Static config wins: a namedMailboxes entry is a hard override (handy for
    // local testing / pinning a name to a specific mailbox). Normal resolution
    // falls through to the hermes gateway's /api/service_mappings, the
    // authoritative naming source.
    const configAddress = config.hermes.namedMailboxes?.[logical];
    if (configAddress) return asMailboxAddress(configAddress);

    const mappings = await GlobalClient.get().fetchServiceMappings();
    const address = mappings.mappings[logical];
    if (address) return address as MailboxAddress;

    throw new Error(`No mailbox mapping found for: ${logical}`);
  }
}

export const nameMappingService = new NameMappingService();
